import { ReactNode } from 'react';
import { Navigate, RouteProps, useLocation } from 'react-router-dom';

import Loading from '@/components/Loading';
import { usePtContext } from '@/contexts/PtContext';
import useUserLoggedIn from '@/hooks/useUserLoggedIn';
import { isSessionExpired } from '@/lib/sessionExpiry';

import type { AuthType } from './routes';

type RestrictedRouteProps = {
  auth?: Extract<AuthType, 'AuthenticatedOnly' | 'UnauthenticatedOnly'>;
  children?: ReactNode;
} & RouteProps;

const RestrictedRoute = ({ auth, children }: RestrictedRouteProps) => {
  const isLoggedIn = useUserLoggedIn();
  const { isAuthLoading } = usePtContext();
  const { pathname = '', search = '' } = useLocation();

  if (isAuthLoading) return <Loading />;

  if (auth === 'AuthenticatedOnly' && !isLoggedIn) {
    return <Navigate to='/login' state={pathname ? { from: `${pathname}${search}` } : undefined} replace />;
  } else if (auth === 'UnauthenticatedOnly' && isLoggedIn && !isSessionExpired()) {
    return <Navigate to={{ pathname: '/discover/dashboard' }} replace />;
  }

  return children;
};

export default RestrictedRoute;
